import { StrapiType, StrapiCollectionType } from "@/src/type";

function exchangeSectionSlugForActiveId(
  sections?: StrapiType.StrapiCollectionWrapper<StrapiCollectionType.DynamicPageSection<any>>,
  sectionSlug?: string
): number | undefined {
  if (!sectionSlug || (sections?.data ?? []).length === 0) {
    return;
  }

  let activeId = 0;
  for (const section of sections?.data ?? []) {
    if (section.attributes.slug === sectionSlug) {
      return activeId;
    }
    activeId++;
  }
  return;
}

function checkIfSectionShouldTurnOff(
  searchParams?: Record<string, string | string[] | undefined>,
  hideOnSearchParams?: StrapiType.StrapiTags
): boolean {
  if (!hideOnSearchParams || !searchParams) {
    return true;
  }

  try {
    //@ts-ignore
    const __searchParams = new URLSearchParams(searchParams);
    if (!__searchParams) {
      return true;
    }

    for (const opt of hideOnSearchParams ?? []) {
      if (__searchParams.toString().includes(opt.name)) {
        return false;
      }
    }
  } catch (err) {}

  return true;
}

function removeTopPadding(index: number, page: StrapiCollectionType.DynamicPage) {
  if (index === 0) {
    return undefined;
  }
  const previous = index - 1;
  return (
    typeof page.dynamic_page_sections.data[index].attributes.background?.color === "string" &&
    page.dynamic_page_sections.data[index].attributes.background?.color === page.dynamic_page_sections.data[previous].attributes.background?.color
  );
}

export default {
  exchangeSectionSlugForActiveId,
  checkIfSectionShouldTurnOff,
  removeTopPadding,
};
